module.exports = __webpack_public_path__ + "static/media/hotjar.e62117d6.svg";